(() => {
  const hub = document.querySelector('[data-blog-hub]');
  if (!hub) return;

  const cards = [...hub.querySelectorAll('[data-blog-grid] [data-blog-card]')];
  const categoryButtons = [...hub.querySelectorAll('[data-blog-category]')];
  const categorySelect = hub.querySelector('[data-blog-select]');
  const searchInput = hub.querySelector('[data-blog-search]');
  const count = hub.querySelector('[data-blog-count]');
  const empty = hub.querySelector('[data-blog-empty]');
  const grid = hub.querySelector('[data-blog-grid]');
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(window.BrioI18n.locale).trim();
  let category = 'all';

  function filterArticles() {
    const query = normalize(searchInput.value);
    let visible = 0;
    cards.forEach(card => {
      const categoryMatch = category === 'all' || card.dataset.categories.split(' ').includes(category);
      const searchMatch = !query || normalize(card.dataset.search).includes(query);
      card.hidden = !(categoryMatch && searchMatch);
      if (!card.hidden) visible += 1;
    });
    count.textContent = `${visible} article${visible > 1 ? 's' : ''}`;
    empty.hidden = visible !== 0;
    grid.hidden = visible === 0;
  }

  function setCategory(next, scroll) {
    category = next;
    categorySelect.value = next;
    categoryButtons.forEach(button => {
      const active = button.dataset.blogCategory === next;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    filterArticles();
    if (scroll) hub.querySelector('#brio-blog-all').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  categoryButtons.forEach(button => button.addEventListener('click', () => setCategory(button.dataset.blogCategory, true)));
  categorySelect.addEventListener('change', () => setCategory(categorySelect.value, false));
  searchInput.addEventListener('input', filterArticles);
  filterArticles();
})();